import React, { useEffect, useRef } from 'react';
import { useFormikContext } from 'formik';

import useComparable from '~/commons/hooks/useComparable';
import useInterval from '../../hooks/useInterval';
import useTimeout from '../../hooks/useTimeout';

const FormAutoSave = ({
  submitOn = 0,
  onSubmit = () => {},
  saveOn = 0,
  onSave = () => {},
}) => {
  const isInit = useRef(true);
  const { values } = useFormikContext();

  if (submitOn !== null) {
    useTimeout(() => onSubmit(values), submitOn);
  }
  if (saveOn !== null) {
    useInterval(() => onSave(values), saveOn);
  }

  useEffect(() => {
    if (!isInit.current) onSave(values);

    isInit.current = false;
  }, [useComparable(values)]);

  return <></>;
};

export default FormAutoSave;
